import { Box, Typography, useTheme } from '@mui/material';

import { UserInfo } from '@verantos-dev/data-access-users';
import { ApiWorkflowDialog } from '@verantos-dev/shared-components';

import { useUsersListInfoDialog } from '../hooks/useUsersListInfoDialog';

type PropsType = {
  userData: UserInfo;
};

export const UsersListInfoDialog = (props: PropsType) => {
  const { userData } = props;

  const theme = useTheme();

  const { dialogHeader, title, logHeader, userDetails, logDetails, onClose } =
    useUsersListInfoDialog(userData);

  return (
    <ApiWorkflowDialog
      id={'useInfoDialog'}
      title={dialogHeader}
      size="medium"
      isValidForSubmit={true}
      displayButtons={false}
      onClose={onClose}
    >
      <Box>
        <Typography
          variant="body1"
          color={'#333333'}
          fontWeight={700}
          sx={{ mb: theme.spacing(4) }}
        >
          {title}
        </Typography>

        <Box>{userDetails()}</Box>

        <Typography
          variant="body1"
          color={'#333333'}
          fontWeight={700}
          sx={{ my: theme.spacing(4), pt: theme.spacing(3) }}
        >
          {logHeader}
        </Typography>

        <Box>{logDetails()}</Box>
      </Box>
    </ApiWorkflowDialog>
  );
};

export default UsersListInfoDialog;
